<app-top-menu></app-top-menu>

<div class="justify-content-center">
  <div class="row content-row">
    <div class="p-0 banner-col">
      <img src="assets/img/self-service-payment-banner.jpg" class="self-service-payment-banner" alt />
    </div>

    <div class="form-col " *ngIf="paymentType === 'invoice'">
      <!--₦-->
      <div class="form-wrapper bg-coat">
        <div class="d-flex flex-row align-items-center"></div>
        <!-- <p class="alert alert-warning text-center p-2" style="font-size: 13px">
          Enter all necessory fields, and click continue to pay.
        </p> -->
        <div class="d-flex justify-content-between">
          <h4 class="title text-decoration-underline">Invoice Details</h4>
          <!-- <a class="text-primary" role="button" (click)="back()" *ngIf="invoiceDetailsProcessed">
            Back
          </a> -->
          <b class="igr">Anambra State IGR</b>
  
        </div>
        <div class="input-container">
  
          <form [formGroup]="invoicePaymentForm" class="row g-3 m-0">
            <div class="col-md-6">
              <div class="tax-input-group">
                <label class="mb-0">Invoice Number</label>
                <input class="tax-form-control mt-0" type="text" formControlName="invoiceNumber" />
  
                <app-error-message controlName="invoiceNumber" label="Invoice number"
                  [form]="invoiceValidationForm"></app-error-message>
              </div>
            </div>
  
            <div class="col-md-6 tax-input-group">
              <label>Taxpayer ASIN </label>
              <input class="tax-form-control" formControlName="asin" />
              <app-error-message controlName="asin" label="Taxpayer ASIN" [form]="verifyForm"></app-error-message>
            </div>
            <div class="col-md-6 tax-input-group">
              <label>Taxpayer Name </label>
              <input class="tax-form-control" formControlName="name" />
              <app-error-message controlName="name" label="Taxpayer name" [form]="verifyForm"></app-error-message>
            </div>
            <br />
            <div class="col-md-6 tax-input-group">
              <label>MDA</label>
              <input class="tax-form-control" type="text" formControlName="mda" />
              <app-error-message controlName="mda" label="MDA" [form]="verifyForm"></app-error-message>
            </div>
            <br />
            <div class="col-md-6 tax-input-group">
              <label>Revenue Code</label>
              <input class="tax-form-control" type="text" formControlName="revenueCode" />
              <app-error-message controlName="revenueCode" label="Revenue Code" [form]="verifyForm"></app-error-message>
            </div>
            <br />
            <div class="col-md-6 tax-input-group">
              <label>Amount To Pay</label>
              <input class="tax-form-control" type="text" formControlName="amount" separator />
              <app-error-message controlName="amount" label="Amount To Pay" [form]="verifyForm"></app-error-message>
            </div>
            <br />
            <div class="col-md-6 tax-input-group">
              <label>Date Created</label>
              <input class="tax-form-control" type="text" formControlName="dateCreated" />
              <app-error-message controlName="dateCreated" label="Date created" [form]="verifyForm"></app-error-message>
            </div>
            <br />
            <div class="d-flex flex-column gap-3"  style="border-top: 1px solid rgb(146, 145, 145); padding-top: 20px;">
              <span style='font-weight: normal; '>Select a payment channel and click on the proceed button to continue to payment</span>
  
              <div class="payment-methods">
                <label class="payment-method">
                  <input type="radio" name="type" [checked]="true" value="interswitch" (change)="getType($event)" />
                  <img src="assets/img/interswitch-small.png" alt="" />
                </label>
                <label class="payment-method">
                  <input value="remita" type="radio" name="type" (change)="getType($event)" />
                  <img src="assets/img/remita.png" alt="" />
                </label>
                <label class="payment-method">
                  <input value="paystack" type="radio" name="type" (change)="getType($event)" />
                  <img src="assets/img/paystack.png" alt="" />
                </label>
              </div>
            </div>
            <button [disabled]="invoicePaymentForm?.invalid" style="
                background: #cc9e0a;
                color: #fff;
                font-weight: 600;
                height: 45px;
              " type="button" (click)="submitInvoice()">
  
              <span *ngIf="!isSubmittingInvoicePayment">Proceed To Payment</span>
              <div class="spinner-border text-white" *ngIf="isSubmittingInvoicePayment"></div>
            </button>
          </form>
        </div>
      </div>
  
    </div>
  </div>
</div>
